import { EditProps, RaRecord, useEditController } from 'react-admin';

export function useRecord<T extends RaRecord>(props?: EditProps & any) {
  const ctlProps = useEditController(props);

  return ctlProps.record as T;
}
